export const ecommPusher = {
  ecommPaidChannel: 'ecomm-paid-channel',
  ecommPaidEvent: 'ecomm-paid-event',

  ecommCODChannel: 'ecomm-cod-channel',
  ecommCODEvent: 'ecomm-cod-event',
};
